// @ts-ignore
import { getLogger } from '@jitsi/logger';
import { batch } from 'react-redux';
// @ts-ignore
import TRANSLATION_LANGUAGES from '../../../lang/translation-languages.json';
import i18next from '../../../react/features/base/i18n/i18next';
import { isLocalParticipantModerator } from '../../../react/features/base/participants/functions';
import { showNotification } from '../../../react/features/notifications/actions';
import { NOTIFICATION_ICON, NOTIFICATION_TIMEOUT_TYPE } from '../../../react/features/notifications/constants';
import { toggleLanguageSelectorDialog } from '../../../react/features/subtitles/actions.web';
import { sendStatsToKibana } from '../../../wildix/components/analytics/kibana/actions';
import { KIBANA_MESSAGES } from '../../../wildix/components/analytics/kibana/constants';
import { getRndInteger } from '../conference/functions';
const logger = getLogger('WrongTranscriptionLanguageDetector');
logger.log('init WrongTranscriptionLanguageDetector');
let data = {};
let averageData = {};
let kibanaData = {};
const isAlreadyShown = {};
const isWrongPrevData = {};
const K_TRESHOLD = {
    'en-US': 7,
    'en-GB': 7,
    'fr-FR': 7,
    'de-DE': 7,
    'de-CH': 7,
    'it-IT': 6,
    'es-ES': 7,
    'es-US': 7,
    'ca-ES': 7,
    'eu-ES': 7,
    'he-IL': 7,
    'nl-NL': 8,
    'ru-RU': 7,
    'sv-SE': 7,
    'uk-UA': 7,
    'ar-AE': 7,
    'ar-SA': 7
};
const STABILITY_THRESHOLD = {
    'en-US': 0.6,
    'en-GB': 0.6,
    'fr-FR': 0.6,
    'de-DE': 0.6,
    'de-CH': 0.6,
    'it-IT': 0.5,
    'es-ES': 0.6,
    'es-US': 0.6,
    'ca-ES': 0.6,
    'eu-ES': 0.5,
    'he-IL': 0.6,
    'nl-NL': 0.6,
    'ru-RU': 0.5,
    'sv-SE': 0.5,
    'uk-UA': 0.5,
    'ar-AE': 0.6,
    'ar-SA': 0.6
};
const DEFAULT_K_TRESHOLD = 7;
const DEFAULT_STABILITY_TRESHOLD = 0.5;
const STABILITY_DELTA_TRESHOLD = 0.1;
const MAX_DATA_SIZE = 20;
const MAX_KIBANA_DATA_SIZE = 1;
const MIN_PHRASE_DURATION = 1; // seconds
const MIN_PHRASE_LENGTH = 3; // symbols
const getStability = (lang) => STABILITY_THRESHOLD[lang] || DEFAULT_STABILITY_TRESHOLD;
const getK = (lang) => K_TRESHOLD[lang] || DEFAULT_K_TRESHOLD;
const isSupportedLanguage = (lang) => Boolean(STABILITY_THRESHOLD[lang] && K_TRESHOLD[lang]);
const isReadyToSendKibana = (lang) => Boolean(Array.isArray(kibanaData[lang])
    && kibanaData[lang].length >= MAX_KIBANA_DATA_SIZE);
function calcAverageData(lang) {
    const sum = data[lang].reduce((prevValue, currValue) => {
        if (prevValue) {
            return {
                stability: prevValue.stability + currValue.stability,
                k: prevValue.k + currValue.k
            };
        }
        return currValue;
    }, { stability: getStability(lang),
        k: getK(lang) });
    return {
        k: Math.round(sum.k / data[lang].length),
        stability: Number((sum.stability / data[lang].length).toFixed(2))
    };
}
function isWrongData(lang) {
    const stabilityDelta = Number(Math.abs(averageData[lang].stability - getStability(lang)).toFixed(2));
    logger.log('stability delta, stability delta treshold: ', stabilityDelta, STABILITY_DELTA_TRESHOLD);
    return stabilityDelta >= STABILITY_DELTA_TRESHOLD
        ? averageData[lang].stability < getStability(lang)
        : averageData[lang].k < getK(lang);
}
function showWrongTranscriptionLanguageNotification(language) {
    return (dispatch, _getState) => {
        // @ts-ignore
        const fullLanguage = TRANSLATION_LANGUAGES[language] ?? 'English';
        const notificationData = {
            title: i18next.t('transcribing.wrongTranscriptionLanguageTitle'),
            description: i18next.t('transcribing.wrongTranscriptionLanguageDesc', { language: fullLanguage }),
            icon: NOTIFICATION_ICON.WARNING,
            customActionHandler: [() => batch(() => dispatch(toggleLanguageSelectorDialog()))],
            customActionNameKey: ['transcribing.selectLanguage']
        };
        dispatch(showNotification(notificationData, NOTIFICATION_TIMEOUT_TYPE.LONG));
    };
}
export function detectWrongTranscriptionLanguage(json) {
    return (dispatch, getState) => {
        try {
            const language = json.language;
            const state = getState();
            // Do not detect if guest or not wildix email
            if (!isLocalParticipantModerator(state)) {
                return;
            }
            // Set default values
            if (!Array.isArray(data[language])) {
                data = {};
                averageData = {};
                kibanaData = {};
                data[language] = [];
                kibanaData[language] = [];
                logger.log(`Start to detect new language: ${language}`);
            }
            const stability = json?.stability || DEFAULT_STABILITY_TRESHOLD;
            const phraseLength = json.transcript[0]?.text?.length || 0;
            const phraseDuration = (json.end - json.start) / 1000; // seconds
            // Fill array every time if phrase duration 1+ sec and phrase length 3+ symbols
            if (phraseDuration >= MIN_PHRASE_DURATION && phraseLength >= MIN_PHRASE_LENGTH) {
                data[language].push({
                    stability,
                    k: Math.round(phraseLength / phraseDuration)
                });
            }
            if (data[language].length >= MAX_DATA_SIZE) {
                averageData[language] = calcAverageData(language);
                logger.log(`Full data by ${language} lang:`, data[language]);
                logger.log(`Average data by ${language} lang:`, averageData[language]);
                // If the Stability less than {STABILITY_THRESHOLD} - we decide that the language selected is wrong.
                // If the Stability is so close to {STABILITY_THRESHOLD} - we start to rely on the {K_THRESHOLD}
                // and when K less than {K_THRESHOLD} - we decide that the language selected is wrong.
                // If supported transcription language.
                // If the notification not already shown
                const isWrongCurrentData = isWrongData(language);
                const isWrongLanguage = Boolean(isWrongPrevData[language] && isWrongCurrentData);
                const isShowNotification = isWrongLanguage
                    && isSupportedLanguage(language)
                    && !isAlreadyShown[language];
                if (isShowNotification) {
                    logger.log('MAYBE WRONG LANGUAGE is selected: ', averageData[language]);
                    dispatch(showWrongTranscriptionLanguageNotification(language));
                    // Set flag to prevent showing notification more that once
                    isAlreadyShown[language] = true;
                }
                kibanaData[language].push({
                    language,
                    isWrongLaguageDetected: isWrongCurrentData,
                    isShowNotification,
                    ...averageData[language]
                });
                if (isReadyToSendKibana(language)) {
                    setTimeout(() => {
                        dispatch(sendStatsToKibana(kibanaData[language], KIBANA_MESSAGES.TranscriptionWrongLanguage));
                        kibanaData[language] = [];
                    }, getRndInteger(0, 10000, 500));
                }
                isWrongPrevData[language] = isWrongCurrentData;
                data[language] = [];
                // @ts-ignore
                averageData[language] = {};
            }
        }
        catch (error) {
            logger.warn('Something went wrong during calc data', error);
        }
    };
}
